import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import {
    ModalContent,
    ModalHeader,
    ModalRow,
    ModalRowLabel,
    ModalRowValue,
    ModalSection,
    ModalSectionTitle,
    ModalTitle,
    ScrollableContent,
} from "../../Styles/InputStyles";
import { capitalizeFirstLetter } from "../../../helpers";
import ModalProfileHeader from "../../Common/ModalProfileHeader";
import Tooltip from "../../Tooltip";

const ViewDetails = ({ setViewDetails, selectedData }) => {
    const onClose = () => {
        setViewDetails(false);
    };

    // Get frequency type label
    const getFrequencyLabel = (frequencyType) => {
        const frequencyMap = {
            1: "Daily",
            2: "Weekly",
            3: "Monthly",
            4: "Yearly"
        };
        return frequencyMap[frequencyType] || "--";
    };

    const remainingTransactions = selectedData?.transactionsRemaining || 0;
    const totalTransactions = selectedData?.totalTransactions || 0;
    const paidAmount = Number(selectedData?.paidAmount || 0);
    const totalAmount = Number(selectedData?.totalAmount || 0);
    const outstandingAmount = totalAmount - paidAmount;
    const completedTransactions = totalTransactions - remainingTransactions;
    const progressPercentage = totalTransactions > 0
        ? Math.round((completedTransactions / totalTransactions) * 100)
        : 0;


    return (
        <>
            <Container>
                <ModalHeader>
                    <ModalTitle>Autopay Details</ModalTitle>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </ModalHeader>

                <ModalProfileHeader
                    title="Autopay Details"
                    name={capitalizeFirstLetter(selectedData?.beneficiaryName)}
                    subtitle={
                        <div className="flex items-center gap-1">
                            <span>#{selectedData?.beneficiaryMobile}</span>
                        </div>
                    }
                    amountLabel={"Total Amount"}
                    amount={selectedData?.totalAmount}
                    onClose={onClose}
                />

                <ModalContent>
                    <ScrollableContent>
                        <Wrapper>
                            <BtnWrapper>
                                <ModalSectionTitle>Autopay Information</ModalSectionTitle>

                            </BtnWrapper>
                            <ModalSection>
                                <ModalRow>
                                    {/* <FlexCol>
                                        <ModalRowLabel>Total Amount</ModalRowLabel>
                                        <ModalRowValue>
                                            ₹{Number(selectedData?.totalAmount || 0)}
                                        </ModalRowValue>
                                    </FlexCol> */}
                                    <FlexCol>
                                        <ModalRowLabel>Paid/Outstanding Amount</ModalRowLabel>
                                        <ModalRowValue>

                                            <div className="flex items-baseline gap-1">
                                                <span className="font-semibold">
                                                    {paidAmount}
                                                </span>
                                                <span className="text-xs text-gray-400 font-normal">
                                                    / {outstandingAmount}
                                                </span>
                                            </div>
                                        </ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>Installment Amount</ModalRowLabel>
                                        <ModalRowValue>
                                            ₹{Number(selectedData?.amount || 0)}
                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>

                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Transactions</ModalRowLabel>
                                        <ModalRowValue>

                                            <div className="flex items-baseline gap-1">
                                                <span className="font-semibold">
                                                    {remainingTransactions}
                                                </span>
                                                <span className="text-xs text-gray-400 font-normal">
                                                    / {totalTransactions}
                                                </span>
                                            </div>
                                        </ModalRowValue>
                                    </FlexCol>

                                    <FlexCol>
                                        <ModalRowLabel>Category</ModalRowLabel>
                                        <ModalRowValue>
                                            {selectedData?.expenseTypeName || "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>

                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Frequency</ModalRowLabel>
                                        <ModalRowValue>
                                            {getFrequencyLabel(selectedData?.frequencyType)}
                                        </ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>Installment Date</ModalRowLabel>
                                        <ModalRowValue>
                                            {selectedData?.nextDueDate
                                                ? moment(selectedData.nextDueDate).format("DD MMM, YYYY")
                                                : "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>

                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Created At</ModalRowLabel>
                                        <ModalRowValue>
                                            {selectedData?.createdAt
                                                ? moment(selectedData.createdAt).format("DD MMM YY, hh:mm A")
                                                : "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>Last Updated</ModalRowLabel>
                                        <ModalRowValue>
                                            {selectedData?.updatedAt
                                                ? moment(selectedData.updatedAt).format("DD MMM YY, hh:mm A")
                                                : "--"}
                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>

                            </ModalSection>
                        </Wrapper>
                    </ScrollableContent>
                </ModalContent>
            </Container>
        </>
    );
};

const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;

export default ViewDetails;